export default "__VITE_ASSET__KOXR0ZsZ__"